import { useEffect, useState } from "react";

const Switch: React.FC<{
  id?: string;
  className?: string;
  checked?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'default';
}> = ({
  id,
  className,
  checked, // 默认值
  onChange,
  disabled,
  size = 'default'
}) => {
    const [isChecked, setIsChecked] = useState<boolean | undefined>(checked)
    useEffect(() => {
      setIsChecked(checked)
    }, [checked])

    const onInputChangeHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked
      setIsChecked(checked)
      if (onChange) onChange(checked)
    }
    return (
      <label id={id} className={`${className}`}>
        <input
          type="checkbox"
          className="sr-only"
          checked={isChecked}
          onChange={onInputChangeHandle}
          disabled={disabled}
        />
        <div className={`rounded-full transition-all flex
          ${isChecked ? 'bg-sprimary-600' : 'bg-gray-200'}
          ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
          ${size === 'default' ? 'h-5 w-10' : 'h-3 w-5'}
        `}>
          <span className={`
            inline-block bg-white border rounded-full transition-all
            ${size === 'default' ? 'h-5 w-5' : 'h-3 w-3'}
            ${isChecked ? size === 'default' ? 'ml-6' : 'ml-3' : 'ml-0'}
          `}></span>
        </div>
      </label>
    )
  }
export default Switch